import React, { useEffect, useState, useRef, useMemo } from "react";
import { Input } from "react-daisyui";
import { MdOutlineCheck, MdOutlineClose } from "react-icons/md";
import { Link, useNavigate, useParams } from "react-router-dom";
import { observer } from "mobx-react";
import { useCmsStore, CmsStore, CmsStoreContext } from "../Store/CmsStore";
import JoditEditor from "jodit-react";
import { useCallback } from "react";

const EditCmsManagement = observer(() => {
  const { id } = useParams();
  return (
    <CmsStoreContext.Provider
      value={
        new CmsStore({
          loadeditcitybol: false,
          editloading: true,
          id: id,
        })
      }
    >
      <Screen />
    </CmsStoreContext.Provider>
  );
});
export default EditCmsManagement;

const Screen = observer(() => {
  // const [contents, setContent] = useState("");
  // const placeholder = "hy raj";
  const {
    saved,
    title,
    content,
    status,
    updatedcms,
    getbytitle,
    getcontent,
    getstatus,
  } = useCmsStore();
  const { id } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    if (saved) {
      navigate("../cmsmanagement");
    }
  }, [saved]);
  const editor = useRef(null);

  const onChange = useCallback(
    (newContent) => {
      getcontent(newContent);
    },
    [content]
  );
  return (
    <>
      <div className="flex justify-between">
        <div className=" mb-4">
          <p className=" text-2xl font-semibold text-moredarkgreen">Edit Cms</p>
          {/* <p className=" opacity-80 text-sm">Home / Cms / Edit</p> */}
        </div>
        <div>
          <Link
            to="../cmsmanagement"
            className="btn btn-sm bg-darkgreen text-yellow text-sm hover:bg-yellow hover:text-darkgreen "
          >
            Back
          </Link>
        </div>
      </div>
      <div className="card bg-base-100 shadow-md p-6 mt-8 overflow-auto">
        <form
          onSubmit={(e) => {
            updatedcms(id);
            e.preventDefault();
          }}
        >
          <div className="grid lg:grid-cols-3 md:grid-cols-2 md:gap-8 gap-4">
            <div>
              <label
                htmlFor="Fees"
                className="block text-sm font-semibold text-zinc-700 dark:text-stone-400 mb-2"
              >
                Title<span className="text-[#f00] ">&nbsp;*</span>
              </label>
              <Input
                name="Coupon Name"
                required
                placeholder="Title"
                onChange={(e) => getbytitle(e.target.value)}
                value={title}
                id="Coupon Name"
                type="text"
                autoComplete="off"
                className="focus:outline-0 w-full text-sm font-medium rounded-md"
              />
            </div>
            {/* <div>
                        <label htmlFor="Fees" className="block text-sm font-semibold text-zinc-700 dark:text-stone-400 mb-2">Content<span className="text-red-500">&nbsp;*</span></label>
                        <Input 
                        name="Coupon Code"
                        required
                        placeholder="Coupon Code" 
                        onChange={(e) => getcontent(e.target.value)}
                        value={content}
                        id="Coupon Code" 
                        type="text" 
                        autoComplete="off" 
                        className="focus:outline-0 w-full text-sm font-medium rounded-md"
                        />
                    </div> */}

            <div>
              <label
                htmlFor="status"
                className="block text-sm font-semibold text-zinc-700 dark:text-stone-400 mb-2"
              >
                Status<span className="text-[#f00]">&nbsp;*</span>
              </label>
              <select
                name="Status"
                required
                onChange={(e) => getstatus(e.target.value)}
                value={status}
                className={`select focus:outline-0 w-full text-sm font-medium rounded-md focus:outline-offset-0 select-bordered`}
              >
                <option value={"1"}>Active</option>
                <option value={"0"}>Inactive </option>
              </select>
            </div>
          </div>
          <div className="grid  mt-7  md:gap-8 gap-4">
            <JoditEditor
              ref={editor}
              value={content}
              tabIndex={1}
              onChange={onChange}
            />
          </div>
          <div className="lg:mt-3 mt-4 flex items-center md:justify-end justify-between">
            <Link
              to="../cmsmanagement"
              className="btn btn-md bg-darkgreen text-[#fff] text-sm hover:text-darkgreen hover:bg-lightgreen "
            >
              <MdOutlineClose className="mr-1" />
              Cancel
            </Link>
            <button className="btn btn-md bg-lightgreen text-darkgreen text-sm hover:bg-darkgreen hover:text-[#fff]   ml-4">
              <MdOutlineCheck className="mr-1" />
              Update
            </button>
          </div>
        </form>
      </div>
    </>
  );
});
